import { render, staticRenderFns } from "./RiskFourColorChart.vue?vue&type=template&id=39b2c32a&scoped=true"
import script from "./RiskFourColorChart.vue?vue&type=script&lang=js"
export * from "./RiskFourColorChart.vue?vue&type=script&lang=js"
import style0 from "./RiskFourColorChart.vue?vue&type=style&index=0&id=39b2c32a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2c32a",
  null
  
)

export default component.exports